module.exports = "<div class=\"spinner\">\n  <div class=\"rect1\"></div>\n  <div class=\"rect2\"></div>\n  <div class=\"rect3\"></div>\n  <div class=\"rect4\"></div>\n  <div class=\"rect5\"></div>\n</div>\n\n<div class=\"display\" *ngIf=\"showDisplay\">Carregando...</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/shared/components/spinner/spinner.component.html
 ** module id = 123
 ** module chunks = 0
 **/